module.exports = __webpack_public_path__ + "media/v2/alsendo-49472024.svg";